/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignInterviewSettingsUpdatePathParams,
	CampaignInterviewSettingsUpdateRequest,
	CampaignInterviewSettingsUpdateResponse,
} from '../types/CampaignInterviewSettingsUpdate'

/**
 * PUT /interview-scheduling/campaigns/:campaign/interview-settings
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/CampaignInterviewSettingsController.php CampaignInterviewSettingsController::update
 */
export async function campaignInterviewSettingsUpdate(
	campaign: CampaignInterviewSettingsUpdatePathParams['campaign'],
	data: CampaignInterviewSettingsUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignInterviewSettingsUpdateResponse>> {
	return axiosInstance.put(`/interview-scheduling/campaigns/${campaign}/interview-settings`, data, config)
}
